import React from 'react';
import Seo from '../components/Seo';
import './CustomDevPricing.css';

const CustomDevPricing = () => {
  return (
    <div className="custom-dev-pricing">
      <Seo
        title="Custom Development Pricing | Clean Sweeps"
        description="Pricing and scope for custom Clean Sweeps development, integrations, and storefront extensions."
        path="/custom-dev-pricing"
        image="/og/custom-dev-pricing.png"
        imageAlt="Custom development pricing"
      />
      <div className="pdf-container">
        <iframe
          src="/assets/CustomDevPricing.pdf#toolbar=0&navpanes=0&scrollbar=1"
          title="Custom Development Pricing"
          width="100%"
          height="800px"
          style={{
            border: 'none',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
        >
          <p>
            Your browser does not support PDFs. 
            <a href="/assets/CustomDevPricing.pdf" target="_blank" rel="noopener noreferrer">
              Download the PDF
            </a>
          </p>
        </iframe>
      </div>
    </div>
  );
};

export default CustomDevPricing;
